module.exports = __webpack_public_path__ + "fonts/FuturaStd-Light.34e6da98.otf";